<style></style>

<template>
    <div class="page-rule-logs">
        <div class="toolbars mrgb5">
            <div class="buttons mrgb5">
                <div class="fl">
                    <el-alert class="mrgb10" type="error" :closable="false" size="medium" v-if="isDetailQuery">
                        <span slot="title">
                            {{ tranceRuleType(listQuery.handleType) }}变更日志
                        </span>
                    </el-alert>
                </div>
                <div class="fr">
                    <el-select class="c-el-input c-el-input-small mrgr5 mrgb5" placeholder="绩效类型" size="medium" filterable
                        :disabled="isDetailQuery"
                        clearable v-model="listQuery.handleType" @change="_search()">
                        <el-option v-for="t in ruleTypeOptions" :key="t.value" :label="t.label" :value="t.value"></el-option>
                    </el-select>
                    <el-input class="c-el-input c-el-input-small mrgr5 mrgb5" placeholder="关键字查询" clearable v-model="listQuery.keywords"
                        size="medium"></el-input>
                    <el-button type="primary" size="medium" @click="_search()"><i class="fa fa-search"></i> 查询</el-button>
                </div>
            </div>
        </div>
        <el-table :data="tableData" style="width: 100%" border size="medium">
            <el-table-column label="日志记录" prop="handleLog" min-width="200"></el-table-column>
            <el-table-column label="类型" prop="handleTypeDesc"></el-table-column>
            <el-table-column label="操作者" prop="operator"></el-table-column>
            <el-table-column label="更新时间" prop="creationTime" :formatter="tableDateFormat" width="160"></el-table-column>
        </el-table>

        <div class="pagination-container" v-if="isPagination">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" 
                :current-page="listQuery.page" :page-sizes="appPageSizes" :page-size="listQuery.size" 
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import permission from "@/mixins/permission"
import * as funMaintenance from '@/api/maintenance'
export default {
    name: "pageRuleLogs",
    mixins: [permission],
    data() {
        return {
            tableData: [],
            total: null,
            defaultQueryParams: {
                handleType: 0,
                keywords: "",
                page: 1,
                size: window.$common.appPageSize,
                sorting: "creationTime DESC"
            },
            listQuery: {},
            isPagination: false,
            ruleTypeOptions: [
                {
                    label: "挪车规则",
                    value: 0
                },
                {
                    label: "换电规则",
                    value: 1
                },
                {
                    label: "维修规则",
                    value: 2
                }
            ],
            isDetailQuery: false
        }
    },
    mounted() {
        this.open()
    },
    methods: {
        open(params) {
            // 重置查询参数
            this.listQuery = { ...this.defaultQueryParams }
            // 带参数查询
            if (params) {
                this.isDetailQuery = true
                this.listQuery.handleType = params.handleType || 0
                this.listQuery.keywords = params.keywords || ""
                this._search()
            } else {
                this.isDetailQuery = false
                setTimeout(() => {
                    if (!this.isDetailQuery) {
                        this._search()
                    }
                }, 500);
            }
        },
        handleSizeChange(val) {
            window.$common.fullLoading()
            this.listQuery.size = val
            this.getDataList()
        },
        handleCurrentChange(val) {
            window.$common.fullLoading()
            this.listQuery.page = val
            this.getDataList()
        },
        getDataList() {
            window.$common.fullLoading()
            funMaintenance.GetOperatorHandleLogs(this.listQuery).then(response => {
                window.$common.closeFullLoading()
                this.total = response.totalCount
                this.isPagination = response.totalCount > 0 || false
                if (response && response.items && response.items.length > 0) {
                    this.tableData = response.items.map(t => {
                        t.handleTypeDesc = this.tranceRuleType(t.handleType)
                        return t
                    })
                } else {
                    this.tableData = []
                }
            })
        },
        _search() {
            this.listQuery.page = 1
            this.getDataList()
        },
        tranceRuleType(type) {
            // 通过ruleTypeOptions获取label
            let label = this.ruleTypeOptions.find(t => t.value == type)?.label || ""
            return label
        }
    }
}
</script>